// extracted by mini-css-extract-plugin
export default {"generalThreeDotsSpinner":"loading_generalThreeDotsSpinner__AzWxM"};